<template>
  <div>
    <q-page>
      <div class="q-pa-md">
        <div class="row q-col-gutter-md">
          <div class="col-12">
            <div class="row justify-between">
              <div>
                <div class="row">
                  <div class="page-title q-mr-sm">Sources</div>
                  <div>
                    <q-btn
                      color="primary"
                      class="float-right sustainability-button"
                      @click="onAddSourcesClick"
                    >
                      <q-icon name="mdi-plus-circle"> </q-icon>
                      <span
                        class="sustainability-font q-mx-sm"
                        style="font-size: 13px"
                      >
                        Add
                      </span>
                    </q-btn>
                  </div>
                </div>
              </div>

              <div class="row">
                <q-select
                  style="max-width: 70%"
                  class="searchbar float-right"
                  filled
                  dense
                  label="Filter by Type"
                  v-model="filterByType"
                  :options="['All', 'Data', 'Scale']"
                >
                </q-select>
                <q-select
                  clearable
                  style="max-width: 70%"
                  class="searchbar float-right"
                  filled
                  dense
                  label="Filter by Outcomes"
                  v-model="filterByOutcome"
                  :options="outcomesList"
                  map-options
                  option-label="name"
                  emit-value
                >
                </q-select>

                <q-input
                  class="searchbar float-right"
                  style="max-width: 70%"
                  filled
                  v-model="search"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>
          </div>
          <div class="col-12">
            <q-card>
              <div class="row">
                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 195px)"
                >
                  <!-- <data-table
                    flat
                    :data="sourceList"
                    :filter="search"
                    headerBgColor="#162c47"
                    headerTextColor="white"
                    :columns="columns"
                    @rowDoubleClick="onRowDoubleClick"
                  >
                  </data-table> -->
                  <sustainability-datatable
                    flat
                    :data="filteredData"
                    :filter="search"
                    :columns="columns"
                    headerBgColor="#162c47"
                    headerTextColor="white"
                    @rowDoubleClick="onRowDoubleClick"
                    :cellBodyStyle="cellBodyStyle"
                    :pagination="{
                      sortBy: 'name',
                      descending: false,
                      rowsPerPage: 0,
                    }"
                  >
                    <template slot="body-cell-image" slot-scope="data">
                      <q-td :props="data.props">
                        <q-icon
                          size="sm"
                          v-if="data.props.row.imageUrl"
                          name="mdi-check-circle"
                          color="green"
                        >
                        </q-icon>
                      </q-td>
                    </template>
                    <template slot="body-cell-name" slot-scope="data">
                      <q-td :props="data.props">
                        <div
                          style="
                            font-family: 'Montserrat';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 14px;
                            display: flex;
                            color: black;
                          "
                        >
                          {{ data.props.row.name }}
                          <q-chip
                            color="positive"
                            label="Positive"
                            v-if="!data.props.row.negative"
                            dense
                            class="text-white"
                          />
                        </div>
                      </q-td>
                    </template>

                    <template slot="body-cell-solutions" slot-scope="data">
                      <q-td :props="data.props">
                        <a
                          href="#"
                          v-if="
                            data.props.row.solutions &&
                            data.props.row.solutions.length > 0
                          "
                        >
                          <span class="text-center solutionLength">
                            {{ data.props.row.solutions.length }}
                            <q-menu
                              auto-close
                              max-height="400"
                              anchor="bottom right"
                              self="bottom right"
                            >
                              <q-list>
                                <q-item
                                  v-for="(solution, i) in data.props.row
                                    .solutions"
                                  :key="i"
                                  clickable
                                  @click="routeToSolutions(solution)"
                                >
                                  <q-item-section>
                                    {{ solution.title }}
                                  </q-item-section>
                                </q-item>
                              </q-list>
                            </q-menu>
                          </span>
                        </a>
                        <span v-else class="text-center solutionLength"> </span>
                      </q-td>
                    </template>
                    <template slot="body-cell-outcomes" slot-scope="data">
                      <q-td :props="data.props">
                        <div class="row items-center">
                          <div
                            v-for="(outcome, i) in data.props.row.outcomes"
                            :key="i"
                            class="q-mr-sm"
                          >
                            <q-img
                              class="q-mx-auto"
                              style="width: 30px; height: 30px"
                              :src="getOutcomeImage({ name: outcome.name })"
                            >
                            </q-img>
                          </div>
                        </div>
                      </q-td>
                    </template>
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td :props="data.props">
                        <q-btn
                          class="float-right"
                          round
                          flat
                          color="red"
                          icon="mdi-delete"
                          @click="removeSource(data.props.row)"
                          size="md"
                        >
                          <q-tooltip> Remove Source </q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </sustainability-datatable>
                </div>
              </div>
            </q-card>
          </div>
        </div>
      </div>
      <q-dialog v-model="sourceDialog" full-width full-height persistent>
        <sources-form
          class="hide-scrollbar"
          @closeDialog="sourceDialog = false"
          :newSource="newSource"
        >
        </sources-form>
      </q-dialog>
    </q-page>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SourcesForm from "@/components/sources/sourcesForm.vue";
import DataTable from "@/components/datatable/datatable.vue";
import SustainabilityDatatable from "@/components/datatable/sustainabilityDatatable.vue";
import { getOutcomeImage } from "@/functions/getOutcomeImage";
export default {
  data: () => ({
    search: "",
    sourceDialog: false,
    newSource: false,

    //add sources button
    addLoading: false,
    filterByOutcome: "",
    filterByType: "All",
  }),
  mounted() {
    this.$store.dispatch("sources/loadAll");
    this.$store.dispatch("outcomes/loadAll");
    if (this.$route.params.hasOwnProperty("id")) {
      this.openSelectedSource(this.$route.params.id);
    }
  },
  components: {
    DataTable,
    SourcesForm,
    SustainabilityDatatable,
  },
  watch: {
    $route: {
      handler(value) {
        if (value.params.hasOwnProperty("id")) {
          this.openSelectedSource(value.params.id);
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      sourceList: "sources/list",
      outcomesList: "outcomes/list",
    }),
    cellBodyStyle() {
      return "font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 14px;line-height: 17px;display: flex;align-items: center;letter-spacing: -0.02em;color: black;";
    },
    filteredData() {
      let sourceList = [];
      sourceList = this.sourceList.filter((e) => {
        let passed = 0;
        if (this.filterByOutcome) {
          let outcomes = e.outcomes.map((o) => o.name);
          if (outcomes.includes(this.filterByOutcome.name)) {
            passed += 1;
          }
        } else {
          passed += 1;
        }

        if (
          this.filterByType == "All" ||
          e.type == this.filterByType.toLowerCase()
        ) {
          passed += 1;
        }

        return passed == 2;
      });

      return sourceList.filter((e) => e.name != "Unknown Source");
    },
    columns() {
      return [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          style:
            "min-width: 40px;max-width: 40px;width: 40px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "image",
          label: "Image",
          align: "center",
          field: "imageUrl",
          style:
            "min-width: 20px;max-width: 20px;width: 20px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",
          style:
            "min-width: 400px;max-width: 400px;width: 400px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "solutions",
          label: "Solutions",
          align: "left",
          field: "solutions",
          style:
            "min-width: 100px;max-width: 100px;width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "outcomes",
          label: "Outcomes",
          align: "left",
          field: "outcomes",
          style:
            "min-width:150px;max-width:150px;width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        // {
        //   name: "status",
        //   label: "Status",
        //   align: "left",
        //   field: "status",
        //   style:
        //     "min-width:100px;max-width:100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        //   sortable: true,
        // },
        {
          name: "createdAt",
          label: "Created At",
          align: "left",
          field: "created_at",
          format: (val) => {
            return this.$options.filters.gridDateFormat(val);
          },
          style:
            "min-width:300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "right",
        },
      ];
    },
  },
  methods: {
    async onAddSourcesClick() {
      this.addLoading = true;
      let result = await this.$store.dispatch("sources/new", {
        status: "temp",
      });
      // this.$store.dispatch("basicGoals/new", {
      //   soruces_id: result.Response.newSourceId,
      //   status: "temp",
      // });
      this.addLoading = false;
      this.$router.push("/sources/" + parseFloat(result.Response.newSourceId));
    },
    onRowDoubleClick(row) {
      this.$router.push("/sources/" + row.id);
    },
    openSelectedSource(id) {
      this.$store.dispatch("outcomes/loadAll");
      this.$store.dispatch("solutions/loadAll");
      this.$store.dispatch("sources/loadSourceByID", id);
      this.$store.dispatch("outcomes/loadAllOutcomesCategories");
      this.$store.dispatch("outcomes/loadOutcomesSourcesBySourceID", id);
      this.$store.dispatch("basicGoals/loadBySourceID", id);
      this.$store.dispatch("sources/solutions/loadAllBySourceID", id);
      this.$store.dispatch("sources/emissionsFactor/loadAllBySourceID", id);
      this.$store.dispatch("units/loadAll");
      this.$nextTick(() => {
        this.sourceDialog = true;
      });
    },
    routeToSolutions(solution) {
      this.$router.push("/solutions/" + solution.id);
    },
    getOutcomeImage: (outcome) => getOutcomeImage(outcome),
    removeSource(source) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete this Item. This is irreversible",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      }).then(async (res) => {
        if (res.value) {
          let payload = { ...source };
          payload.deleted_at = true;
          this.$store.dispatch("sources/save", payload).then((result) => {
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "The Source has been removed.",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
}

.hide-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.solutionLength {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}

.sustainability-button {
  height: 34px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
  line-height: 11px;
  display: flex;
  align-items: center;
  text-align: center;
}
</style>
